const base = {
  colors: {
    backgound: {
      hex: '#F9F6EA',
      rgb: '249, 246, 234, 1',
    },
    backgroundSecondary: {
      hex: '#f6f6f7',
      rgb: '246, 246, 247, 1',
    },
    chevron: {
      hex: '#5c5f62',
      rgb: '225, 227, 229, 1',
    },
    destructive: {
      hex: '#e32b56',
      rgb: '227, 43, 86',
    },
    divider: {
      hex: '#e1e3e5',
      rgb: '225, 227, 229, 1',
    },
    font: {
      primary: {
        hex: '#0B2327',
        rgb: '11, 35, 39, 1',
      },
      secondary: {
        hex: '#8C9196',
        rgb: '140, 145, 150, 1',
      },
    },
    givzGreen: {
      hex: '#37746b',
      rgb: '55, 116, 107',
    },
    givzGreenDark: {
      hex: '#044138',
      rgb: '4 65 56',
    },
    primary: {
      hex: '#C9DF4C',
      rgb: '201, 223, 76, 1',
    },
    secondary: {
      hex: '#8C9196',
      rgb: '140, 145, 150, 1',
    },
    secondaryLight: {
      hex: '#E4E5E7',
      rgb: '228, 229, 231, 1',
    },
    surfaceCritical: {
      hex: '#FED3D1',
      rgb: '254, 211, 209',
    },
    surfaceSuccess: {
      hex: '#AEE9D1',
      rgb: '174,233,209',
    },
  },
  space: {
    default: '1.6rem',
  },
};

export default base;
